// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg viewBox=%270 0 32 32%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath stroke=%27%23fff%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 d=%27M4 8h24M4 16h24M4 24h24%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
*
* ==========================================
* CUSTOM UTIL CLASSES
* ==========================================
*
*/

.form-control:focus {
    box-shadow: none;
  }
  
  .form-control-underlined {
    border-width: 0;
    border-bottom-width: 1px;
    border-radius: 0;
    padding-left: 0;
  }
  
  /*
  *
  * ==========================================
  * FOR DEMO PURPOSE
  * ==========================================
  *
  */
  
  body {
    background: #000;
    /* background: #17161b; */
    /* background: -webkit-linear-gradient(to right, #fddfb0, #c4dbeb); */
    /* background: linear-gradient(to right, #ffd89b, #e8eaeb); */
    min-height: 100vh;
    font-weight: 500;
    font-family: sans-serif;
  }
  
  .form-control::placeholder {
    font-size: 0.95rem;
    color: #aaa;
    font-style: italic;
  }

  .salon_user_button{
    background-color: #fff!important; 
    border: 1px solid #000;
    /* background-color: #fcbc0b!important; */
    /* width: 35%; */
  }

  .salon_user_button_completed{
    background-color: green!important;
    color:#fff
  }
  .search_icon{
      color: #000;
      /* color: #fcbc0b; */
  }
  .customized_border{
      border-color: #000!important;
      /* border-color: #fcbc0b!important; */
      border-radius: 7px;
  }

  /* SALON LIST SCROLL START */
  .scrolling-wrapper {
    overflow-x: auto;
  }
  .subtitle {
    font-size: 1.5em;
    font-weight: 800;
    /* opacity: 0.65; */
  }
  
  .card-block {
    height: 80px;
    background-color: #fff;
    border: none;
    background-position: center;
    background-size: cover;
    transition: all 0.2s ease-in-out !important;
    border-radius: 15px;
  }
  .card-block:hover {
    transform: translateY(-5px);
    box-shadow: none;
    opacity: 0.9;
  }
  
  .services_class{
    width:16vw
  }
  .mb_custom{
    margin-bottom: 5rem;
  }
  .signup_Text{
    text-align: left;
    font-size: 45px;
    font-weight: 900;
    color:#fff
    /* margin-left: 20px; */
  }

.box_shadow{
  border-radius: 10px;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  padding-top: 10px;
  padding-bottom: 10px;
}
.shadow_class__{
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 15px -2px;
  border-radius: 10px;
  margin-left: 10px;
  margin-right: 10px;
}
.shadow_class__for_services__{
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 15px -2px;
  border-radius: 10px;
}
.all_services_salon_name_text{
  text-align: left;
  margin-top: 20px;
  font-weight: 800;
}
.all_services_salon_box{
  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
}
.custom_rating{
  position: absolute;
  /* bottom: 17%; */
  top:0;
  right:10px
}
.all_services_salon_name_details_text{
  text-align: left;
}
.all_services_salon_name_distance_text{
  text-align: left;
  margin-top: -15px;
}
.hr_dashed_tag{
  border-top: 2px dashed black;
}
.salon_details_service_name{
  font-weight: 800;
}
.salon_details_box{
  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
  padding: 20px;
}
/* .proceed_button{
  position: fixed;
  z-index: 999;
  bottom: 71px;
  left: 50%;
  transform: translateX(-50%);
  width:70%
} */
.text_align_for_image{
  text-align: right;
}
.shadow_class__for_services__selected{
  border: 1px solid grey;
  padding-top: 5px;
  border-radius: 10px;
  background-color: #f4f4f4;
}
.shadow_class__for_services__selected_time{
  border: 1px solid grey;
  border-radius: 10px;
  background-color: #f4f4f4;
}

.pagination {
  margin: 15px auto;
  display: flex;
  list-style: none;
  outline: none;
  color: #fff;

}
.pagination > .active > a{
  background-color: black ;
  border-color: #6ACF65 ;
  color: #000;
}
.pagination > li > a{
  border: 1px solid #6ACF65 ;
  padding: 5px 8px;
  outline: none;
  cursor: pointer;
}
.pagination > .active > a, .pagination > .active > span, .pagination > .active > a:hover, .pagination > .active > span:hover, .pagination > .active > a:focus, .pagination > .active > span:focus{
  background-color: #6ACF65 ;
  border-color: #6ACF65;
  outline: none ;
}
.pagination > li > a, .pagination > li > span{
  color: #6ACF65
}
.pagination > li:first-child > a, .pagination > li:first-child > span, .pagination > li:last-child > a, .pagination > li:last-child > span{
  border-radius: unset
}


.zoom {
  transition: transform .2s;
}

.zoom:hover {
  transform: scale(1.1);
}
.nav-link{
  color: #6ACF65
}
.nav-link:hover{
  color: #fff
}
.for_shadow{
  box-shadow: 4px 5px 12px 1px #212529;
}
.flex-container {
  display: flex;
}
@media only screen and (max-width: 600px) {
  .flex-container {
    flex-direction: column;
  }
}
.some{
  width: 100%;
}
@media only screen and (max-width:600px){
  .desktop{
    font-size: 50px!important;
  }
}
@media only screen and (max-width:600px){
  .for_mobile{
    float: left!important;
    text-align: left;
  }
}
@media only screen and (min-width:821px){
  .to_hide_somewhere{
    display: none;
  }
}
@media only screen and (max-width:820px){
  .to_hide_somewhere__{
    display: none;
  }
}
@media only screen and (max-width:600px){
.mob_logo{
width: 30vw!important;
}
}

.modal-content {
background: #151426;
color: #fff;
}

.custom-toggler .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}


.custom-toggler.navbar-toggler {
  border-color: #fff;
} 

.marquee-container {
  overflow: hidden;
  white-space: nowrap;
  color:#fff;
  padding: 10px;
  background-color: #151426;
}

.marquee-content {
  display: inline-block;
  animation: marquee 20s linear infinite;
  transform: translateX(100%);
}

@keyframes marquee {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(-100%);
  }
}
.first_sec_ran{
  /* background-image: url('../Images/FIRST_sec.png'); */
  /* background-image: url('../NewImg/bg.jpg'); */
}
.card_back{
  /* background-image: url('../Images/stakesubscription.png'); */
  /* background-image: url('../NewImg/bg.jpg'); */
  background-color: #151426;
  
  background-size: cover;
}
@media screen and (max-width: 768px) {
  #tradingview-chart-container {
    height: 300px; /* Adjust height for smaller screens */
  }
}

input[type=number]::-webkit-inner-spin-button, 
input[type=number]::-webkit-outer-spin-button {
    appearance: none;
    margin: 0; 
}`, "",{"version":3,"sources":["webpack://./src/CSS/Style.css"],"names":[],"mappings":"AAAA;;;;;;CAMC;;AAED;IACI,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,wBAAwB;IACxB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;;;;;;GAMC;;EAED;IACE,gBAAgB;IAChB,yBAAyB;IACzB,qEAAqE;IACrE,6DAA6D;IAC7D,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,gCAAgC;IAChC,sBAAsB;IACtB,yCAAyC;IACzC,gBAAgB;EAClB;;EAEA;IACE,iCAAiC;IACjC;EACF;EACA;MACI,WAAW;MACX,oBAAoB;EACxB;EACA;MACI,4BAA4B;MAC5B,qCAAqC;MACrC,kBAAkB;EACtB;;EAEA,4BAA4B;EAC5B;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,sBAAsB;IACtB,YAAY;IACZ,2BAA2B;IAC3B,sBAAsB;IACtB,2CAA2C;IAC3C,mBAAmB;EACrB;EACA;IACE,2BAA2B;IAC3B,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE;EACF;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,uBAAuB;EACzB;;AAEF;EACE,mBAAmB;EACnB,qDAAqD;EACrD,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,sDAAsD;EACtD,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,sDAAsD;EACtD,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,4EAA4E;AAC9E;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,KAAK;EACL;AACF;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,4EAA4E;EAC5E,aAAa;AACf;AACA;;;;;;;GAOG;AACH;EACE,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,WAAW;;AAEb;AACA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,aAAa;EACb,eAAe;AACjB;AACA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE;AACF;AACA;EACE;AACF;;;AAGA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE;AACF;AACA;EACE;AACF;AACA;EACE,oCAAoC;AACtC;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,sBAAsB;EACxB;AACF;AACA;EACE,WAAW;AACb;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,qBAAqB;IACrB,gBAAgB;EAClB;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;AACA;AACA,qBAAqB;AACrB;AACA;;AAEA;AACA,mBAAmB;AACnB,WAAW;AACX;;AAEA;EACE,yDAAyP;AAC3P;;;AAGA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;AACA;EACE,sDAAsD;EACtD,+CAA+C;AACjD;AACA;EACE,8DAA8D;EAC9D,+CAA+C;EAC/C,yBAAyB;;EAEzB,sBAAsB;AACxB;AACA;EACE;IACE,aAAa,EAAE,sCAAsC;EACvD;AACF;;AAEA;;IAII,gBAAgB;IAChB,SAAS;AACb","sourcesContent":["/*\n*\n* ==========================================\n* CUSTOM UTIL CLASSES\n* ==========================================\n*\n*/\n\n.form-control:focus {\n    box-shadow: none;\n  }\n  \n  .form-control-underlined {\n    border-width: 0;\n    border-bottom-width: 1px;\n    border-radius: 0;\n    padding-left: 0;\n  }\n  \n  /*\n  *\n  * ==========================================\n  * FOR DEMO PURPOSE\n  * ==========================================\n  *\n  */\n  \n  body {\n    background: #000;\n    /* background: #17161b; */\n    /* background: -webkit-linear-gradient(to right, #fddfb0, #c4dbeb); */\n    /* background: linear-gradient(to right, #ffd89b, #e8eaeb); */\n    min-height: 100vh;\n    font-weight: 500;\n    font-family: sans-serif;\n  }\n  \n  .form-control::placeholder {\n    font-size: 0.95rem;\n    color: #aaa;\n    font-style: italic;\n  }\n\n  .salon_user_button{\n    background-color: #fff!important; \n    border: 1px solid #000;\n    /* background-color: #fcbc0b!important; */\n    /* width: 35%; */\n  }\n\n  .salon_user_button_completed{\n    background-color: green!important;\n    color:#fff\n  }\n  .search_icon{\n      color: #000;\n      /* color: #fcbc0b; */\n  }\n  .customized_border{\n      border-color: #000!important;\n      /* border-color: #fcbc0b!important; */\n      border-radius: 7px;\n  }\n\n  /* SALON LIST SCROLL START */\n  .scrolling-wrapper {\n    overflow-x: auto;\n  }\n  .subtitle {\n    font-size: 1.5em;\n    font-weight: 800;\n    /* opacity: 0.65; */\n  }\n  \n  .card-block {\n    height: 80px;\n    background-color: #fff;\n    border: none;\n    background-position: center;\n    background-size: cover;\n    transition: all 0.2s ease-in-out !important;\n    border-radius: 15px;\n  }\n  .card-block:hover {\n    transform: translateY(-5px);\n    box-shadow: none;\n    opacity: 0.9;\n  }\n  \n  .services_class{\n    width:16vw\n  }\n  .mb_custom{\n    margin-bottom: 5rem;\n  }\n  .signup_Text{\n    text-align: left;\n    font-size: 45px;\n    font-weight: 900;\n    color:#fff\n    /* margin-left: 20px; */\n  }\n\n.box_shadow{\n  border-radius: 10px;\n  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n.shadow_class__{\n  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 15px -2px;\n  border-radius: 10px;\n  margin-left: 10px;\n  margin-right: 10px;\n}\n.shadow_class__for_services__{\n  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 15px -2px;\n  border-radius: 10px;\n}\n.all_services_salon_name_text{\n  text-align: left;\n  margin-top: 20px;\n  font-weight: 800;\n}\n.all_services_salon_box{\n  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;\n}\n.custom_rating{\n  position: absolute;\n  /* bottom: 17%; */\n  top:0;\n  right:10px\n}\n.all_services_salon_name_details_text{\n  text-align: left;\n}\n.all_services_salon_name_distance_text{\n  text-align: left;\n  margin-top: -15px;\n}\n.hr_dashed_tag{\n  border-top: 2px dashed black;\n}\n.salon_details_service_name{\n  font-weight: 800;\n}\n.salon_details_box{\n  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;\n  padding: 20px;\n}\n/* .proceed_button{\n  position: fixed;\n  z-index: 999;\n  bottom: 71px;\n  left: 50%;\n  transform: translateX(-50%);\n  width:70%\n} */\n.text_align_for_image{\n  text-align: right;\n}\n.shadow_class__for_services__selected{\n  border: 1px solid grey;\n  padding-top: 5px;\n  border-radius: 10px;\n  background-color: #f4f4f4;\n}\n.shadow_class__for_services__selected_time{\n  border: 1px solid grey;\n  border-radius: 10px;\n  background-color: #f4f4f4;\n}\n\n.pagination {\n  margin: 15px auto;\n  display: flex;\n  list-style: none;\n  outline: none;\n  color: #fff;\n\n}\n.pagination > .active > a{\n  background-color: black ;\n  border-color: #6ACF65 ;\n  color: #000;\n}\n.pagination > li > a{\n  border: 1px solid #6ACF65 ;\n  padding: 5px 8px;\n  outline: none;\n  cursor: pointer;\n}\n.pagination > .active > a, .pagination > .active > span, .pagination > .active > a:hover, .pagination > .active > span:hover, .pagination > .active > a:focus, .pagination > .active > span:focus{\n  background-color: #6ACF65 ;\n  border-color: #6ACF65;\n  outline: none ;\n}\n.pagination > li > a, .pagination > li > span{\n  color: #6ACF65\n}\n.pagination > li:first-child > a, .pagination > li:first-child > span, .pagination > li:last-child > a, .pagination > li:last-child > span{\n  border-radius: unset\n}\n\n\n.zoom {\n  transition: transform .2s;\n}\n\n.zoom:hover {\n  transform: scale(1.1);\n}\n.nav-link{\n  color: #6ACF65\n}\n.nav-link:hover{\n  color: #fff\n}\n.for_shadow{\n  box-shadow: 4px 5px 12px 1px #212529;\n}\n.flex-container {\n  display: flex;\n}\n@media only screen and (max-width: 600px) {\n  .flex-container {\n    flex-direction: column;\n  }\n}\n.some{\n  width: 100%;\n}\n@media only screen and (max-width:600px){\n  .desktop{\n    font-size: 50px!important;\n  }\n}\n@media only screen and (max-width:600px){\n  .for_mobile{\n    float: left!important;\n    text-align: left;\n  }\n}\n@media only screen and (min-width:821px){\n  .to_hide_somewhere{\n    display: none;\n  }\n}\n@media only screen and (max-width:820px){\n  .to_hide_somewhere__{\n    display: none;\n  }\n}\n@media only screen and (max-width:600px){\n.mob_logo{\nwidth: 30vw!important;\n}\n}\n\n.modal-content {\nbackground: #151426;\ncolor: #fff;\n}\n\n.custom-toggler .navbar-toggler-icon {\n  background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='%23fff' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 8h24M4 16h24M4 24h24'/%3E%3C/svg%3E\");\n}\n\n\n.custom-toggler.navbar-toggler {\n  border-color: #fff;\n} \n\n.marquee-container {\n  overflow: hidden;\n  white-space: nowrap;\n  color:#fff;\n  padding: 10px;\n  background-color: #151426;\n}\n\n.marquee-content {\n  display: inline-block;\n  animation: marquee 20s linear infinite;\n  transform: translateX(100%);\n}\n\n@keyframes marquee {\n  0% {\n    transform: translateX(100%);\n  }\n  100% {\n    transform: translateX(-100%);\n  }\n}\n.first_sec_ran{\n  /* background-image: url('../Images/FIRST_sec.png'); */\n  /* background-image: url('../NewImg/bg.jpg'); */\n}\n.card_back{\n  /* background-image: url('../Images/stakesubscription.png'); */\n  /* background-image: url('../NewImg/bg.jpg'); */\n  background-color: #151426;\n  \n  background-size: cover;\n}\n@media screen and (max-width: 768px) {\n  #tradingview-chart-container {\n    height: 300px; /* Adjust height for smaller screens */\n  }\n}\n\ninput[type=number]::-webkit-inner-spin-button, \ninput[type=number]::-webkit-outer-spin-button { \n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    margin: 0; \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
